export class InsertMetric{
    public static WebMetricAppId: number = 2

    MetricActionTypeId: MetricActionType;
    MetricAppId: number = InsertMetric.WebMetricAppId;    //This is static to show it comes from the web
    MetricAppSourceFeatureId: MetricAppFeature;
    MetricAppSourceFeatureSectionId: MetricAppFeatureSection;
    MetricAppTargetFeatureId: MetricAppFeature;
    MetricAppTargetFeatureSectionId: MetricAppFeatureSection;
    MetricSourcePrimaryValue: string | null;
    MetricSourceSecondaryValue: string | null;
    MetricTargetPrimaryValue: string | null;
    MetricTargetSecondaryValue: string | null;
    MetricJson: string | null;
}

export enum MetricActionType{
    Unknown = 0,
    Open,
    Close,
    Create,
    Update,
    Delete,
    Share,
    AddTo,
    PayNow,
    PayLater,
    Started,
    Completed,
    ARScan,
    ARRender,
    Favourite,
    Refresh,
    Filter,
    Search,
    Sort,
    UploadDocument,
    DownloadInvoice,
    DownloadReceipt,
    DownloadDocument,
    Archive,
    LinkClick,
    NotificationClick,
    BarcodeScan,
    TextScan
}

export enum MetricAppFeature{
    Application = 1,
    Security = 2,
    UserProfile = 3,
    Homepage = 4,
    SendReceive,
    BuyPostage,
    TrackTrace,
    Customs,
    MyPosta,
    FindPrices,
    Bera,
    Waybill,
    PaymentsReceipts,
    RaiseTicket
}

export enum MetricAppFeatureSection{
    //Application
    Launch = 1,
    ChangeLanguage,
    About,
    ChangeRole,
    StaticContentPage,
    PDFViewer,
    ImageViewer,
    SubmitFeedback,

    //Security
    Login,
    Logout,
    ChangePassword,
    ResetPassword,
    Register,

    //UserProfile
    AccountStatement,
    AddressBook,
    AddressDetail,

    //SendReceive & Buy Postage
    Addresses,
    Specification,
    OrderDetails,
    BasketConfirmation,
    Payment,

    //TrackTrace, Waybill & PaymentsReceipts
    List,
    Detail,

    //Customs
    UploadMissingDocuments,
    PayCustoms,
    PayInvoice,
    CustomsCalculator,

    //MyPosta
    MyOrders,
    CompletedOrders,
    ActiveOrders,
    NewOrder,
    MyActivity,
    Notifications,

    //Bera
    Menu,
    Brochures,
    Products,
    PublisherDetail,
    ViewBrochure,
    ShoppingLists,
    ViewShoppingList,
    AddShoppingList,

    //Multiple
    ViewOrder, //All Order Types
    PaymentConfirmation, //All Order Types
    LoginPrompt,
    ExternalUrl,
    Scan
}